<template>
  <PaperClipIcon
    class="w-5 h-5 text-brand-green cursor-pointer"
    @click="copyLink"
  />
  <p class="text-brand-green text-xs ml-1" v-if="copied">copied!</p>
</template>
<script>
import { PaperClipIcon } from "@heroicons/vue/outline"

export default {
  props: {
    url: {
      type: String,
      required: true
    }
  },
  components: {
    PaperClipIcon
  },
  data() {
    return {
      copied: false
    }
  },
  methods: {
    copyLink() {
      window.navigator.clipboard.writeText(this.url)
      this.copied = true
      const that = this
      setInterval(() => {
        that.copied = false
      }, 3000)
    }
  }
}
</script>
